export default __webpack_public_path__ + "static/media/dark-delete-icon.afc57502.svg";